
import { supabase } from "@/integrations/supabase/client";
import { SpotifyTrack } from "./types";

// Extract Spotify track ID from URL
export function extractSpotifyTrackId(url: string): string | null {
  // Handle different Spotify URL formats
  const patterns = [
    /spotify:track:([a-zA-Z0-9]+)/,  // spotify:track:1234567890
    /open.spotify.com\/track\/([a-zA-Z0-9]+)/, // https://open.spotify.com/track/1234567890
    /\/track\/([a-zA-Z0-9]+)/,  // /track/1234567890
  ];

  for (const pattern of patterns) {
    const match = url.match(pattern);
    if (match && match[1]) {
      return match[1];
    }
  }
  
  return null;
}

// Validate Spotify URL
export function isValidSpotifyUrl(url: string): boolean {
  return !!extractSpotifyTrackId(url);
}

// Get track details from Spotify API through Supabase Edge Function
export async function getTrackDetails(trackId: string): Promise<SpotifyTrack | null> {
  console.log("Fetching track details for:", trackId);
  
  try {
    // Get data from Spotify via our edge function
    const { data, error } = await supabase.functions.invoke('spotify-track-details', {
      body: { trackId },
    });
    
    if (error) {
      console.error("Error calling Spotify edge function:", error);
      throw error;
    }
    
    if (!data || !data.name || !data.artist) {
      console.error("Incomplete data returned from Spotify API");
      throw new Error("Could not get complete track details");
    }

    console.log("Retrieved Spotify data:", data);
    return data as SpotifyTrack;
  } catch (error) {
    console.error("Error fetching Spotify data:", error);
    throw error;
  }
}
